/**
 * "Sync Test" (ENG-2291), a debugging look: shows the look's own clock, the
 * seconds since it started on the server clock. Every phone times a look
 * from the same server moment, so in sync, phones side by side (or on video)
 * show the same number, flash white together on each whole second, and their
 * sweeping bars line up. A phone that's behind shows a lower number, flashes
 * late, and its bar trails.
 */

type Ctx = CanvasRenderingContext2D;

/** How long the screen flashes white on each whole second (seconds). */
const FLASH = 0.1;
const SWEEP_COLOR = "#43c5cd";
/** Tenth-of-a-second ticks along the bottom, to read the bar's position. */
const TICKS = 10;

export const renderSyncTest = (ctx: Ctx, w: number, h: number, t: number) => {
  const seconds = Math.max(0, t);
  const fraction = seconds - Math.floor(seconds);
  const flash = fraction < FLASH;

  ctx.fillStyle = flash ? "#ffffff" : "#000000";
  ctx.fillRect(0, 0, w, h);

  // A bar crossing the screen once a second, left to right.
  const bar = Math.max(4, w * 0.02);
  ctx.fillStyle = SWEEP_COLOR;
  ctx.fillRect(fraction * w - bar / 2, 0, bar, h);

  ctx.fillStyle = flash ? "#000000" : "#ffffff";
  for (let i = 0; i <= TICKS; i++) {
    const x = (i / TICKS) * (w - 2) + 1;
    const tick = i % 5 === 0 ? h * 0.06 : h * 0.03;
    ctx.fillRect(x - 1, h - tick, 2, tick);
  }

  ctx.font = `600 ${Math.round(w * 0.2)}px ui-monospace, Menlo, Consolas, monospace`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(seconds.toFixed(2), w / 2, h / 2);
};
